module.exports = __webpack_public_path__ + "static/media/tempareture.89a254af.png";